<template>
  <div>
    <!-- Header -->
    <div class="flex justify-between items-start mb-8 p-6">
      <h1 class="text-2xl font-medium text-gray-800">Activity Log</h1>
      <div class="text-right">
        <div class="text-lg font-medium text-gray-600">40 Operations</div>
        <div class="text-sm text-primary">Last 30 days</div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="mb-2">
      <div class="relative w-full">
        <select
            v-model="selected"
            @change="fetchActivities"
            class="appearance-none w-full bg-transparent text-primary text-base rounded-md pl-3 pr-8 py-2 focus:outline-none cursor-pointer"
        >
          <option value="all">All Dates</option>
          <option value="last30">LAST 30 DAYS</option>
          <option value="last7">LAST 7 DAYS</option>
        </select>
        <component :is="ChevronDown" class="pointer-events-none absolute inset-y-0 top-2 right-2 w-6 h-6 text-primary"/>
      </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto bg-white px-4 py-2 rounded-lg">
      <table class="w-full">
        <thead>
        <tr class="border-b border-gray-200">
          <th class="text-left py-3 px-2 font-medium text-gray-600">Date/time</th>
          <th class="text-left py-3 px-2 font-medium text-gray-600">Transaction Type</th>
          <th class="text-left py-3 px-2 font-medium text-gray-600">Status</th>
          <th class="text-left py-3 px-2 font-medium text-gray-600">Sort Number</th>
          <th class="w-8"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="activity in activities" :key="activity.id" class="border-b border-gray-100 hover:bg-gray-100">
          <td class="py-4 px-2 text-gray-600">{{ formatDate(activity.datetime, 'UTC') }} UTC</td>
          <td class="py-4 px-2 text-primary">{{ activity.transaction_type }}</td>
          <td class="py-4 px-2 text-gray-600">{{ activity.status }}</td>
          <td class="py-4 px-2 text-gray-400">{{ activity.sortNumber }}</td>
          <td class="py-4 px-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"></path>
            </svg>
          </td>
        </tr>
        </tbody>
      </table>
      <!-- Pagination Info -->
      <!--            <div class="flex justify-end px-2 py-4 bg-white">-->
      <!--                <span class="text-sm text-gray-500">Items 1 - 5</span>-->
      <!--            </div>-->

      <div class="flex justify-between items-center px-2 py-4 bg-white">
  <span class="text-sm text-gray-500">
    Page {{ pagination.current_page }} of {{ pagination.last_page }}
    ({{ pagination.total }} items)
  </span>

        <div class="flex gap-2">
          <button
              :disabled="pagination.current_page === 1"
              @click="fetchActivities(pagination.current_page - 1)"
              class="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>
          <button
              :disabled="pagination.current_page === pagination.last_page"
              @click="fetchActivities(pagination.current_page + 1)"
              class="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>

    </div>

  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import {ChevronDown} from 'lucide-vue-next'
import api from '@/services/api'
import {formatDate} from '@/utils/date.js'


const selected = ref('last7');
const pagination = ref({}) // اطلاعات paginate
const activities = ref([])


const fetchActivities = async (page = 1) => {
  try {
    const res = await api.get('/activity-logs', {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      params: {filter: selected.value, page}
    })
    activities.value = res.data.data
    pagination.value = {
      current_page: res.data.current_page,
      last_page: res.data.last_page,
      total: res.data.total
    }
  } catch (err) {
    console.error("Error fetching activity logs:", err.response?.data || err)
  }
}


onMounted(fetchActivities)


</script>
